(() => {
  'use strict';
  if (window.__ovPdpPolish) {
    window.__ovPdpPolish.refresh?.();
    return;
  }

  const state = { timer: null };

  const variantSets = () => {
    const all = [];
    document.querySelectorAll('script[data-ov-variant-media]').forEach((node) => {
      try {
        const parsed = JSON.parse(node.textContent || '[]');
        if (Array.isArray(parsed)) all.push(...parsed);
      } catch (_) {}
    });
    return all;
  };

  const imageFor = (variants, optionIndex, value) => {
    const exact = variants.find((variant) => {
      const options = Array.isArray(variant.options) ? variant.options : [];
      return String(options[optionIndex] ?? '') === String(value ?? '');
    });
    return exact?.featured_image?.src || exact?.featured_media?.preview_image?.src || exact?.image?.src || '';
  };

  // Shopify CDN derivatives for small swatches. Preserve version/cache parameters
  // and leave non-Shopify/external images unchanged.
  const thumbnailUrl = (src, width) => {
    try {
      const url = new URL(src, document.baseURI);
      const shopifyImage = url.hostname === 'cdn.shopify.com' ||
        (url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/'));
      if (!shopifyImage || !/^https?:$/.test(url.protocol)) return src;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return src; }
  };

  const decorate = () => {
    const variants = variantSets();
    if (!variants.length) return;

    document.querySelectorAll("variant-selects .product-form__input input[type='radio']").forEach((input) => {
      const match = String(input.name || '').match(/-(\d+)$/);
      if (!match) return;
      const optionIndex = Math.max(0, Number(match[1]) - 1);
      const src = imageFor(variants, optionIndex, input.value);
      if (!src) return;

      const label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;

      label.classList.add('ov-has-variant-image');
      let img = label.querySelector('.ov-real-variant-thumb');
      if (!img) {
        img = document.createElement('img');
        img.className = 'ov-real-variant-thumb';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.setAttribute('aria-hidden', 'true');
        label.prepend(img);
      }
      // The Liquid picker already supplies a thumbnail scaled to the merchant's
      // chosen swatch size (3x). Keep it instead of downloading an original or
      // replacing it with a second image request.
      if (label.dataset.ovVariantImage) {
        if (img.getAttribute('src') !== label.dataset.ovVariantImage) {
          img.setAttribute('src', label.dataset.ovVariantImage);
        }
        return;
      }
      const small = thumbnailUrl(src, 120);
      const large = thumbnailUrl(src, 240);
      if (small !== large) {
        const srcset = `${small} 120w, ${large} 240w`;
        if (img.getAttribute('srcset') !== srcset) img.setAttribute('srcset', srcset);
        // Existing swatches are at most 80 CSS px; 240px preserves 3x displays.
        if (img.getAttribute('sizes') !== '80px') img.setAttribute('sizes', '80px');
      } else {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
      if (img.getAttribute('src') !== small) img.setAttribute('src', small);
    });
  };

  const schedule = () => {
    clearTimeout(state.timer);
    state.timer = setTimeout(decorate, 40);
  };

  window.__ovPdpPolish = { refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate, { once: true });
  else decorate();

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('change', (event) => {
    if (event.target?.matches?.("variant-selects input[type='radio'], variant-selects select")) schedule();
  }, true);

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
